import { auth, db } from "@/plugins/firebase";

export const state = {
    currentUser: null,
    loggedIn: false,
    userToken: null,
    userRole: null,
}

export const mutations = {
    SET_CURRENT_USER(state, newValue) {
        state.currentUser = newValue
    },
    SET_USER_TOKEN(state, token) {
        state.userToken = token;
    },
    SET_USER_ROLE(state, claims) {
        state.userRole = claims;
    },
    SET_LOGGED_IN(state) {
        state.loggedIn = true;
    },
    SET_LOGGED_OUT(state) {
        state.loggedIn = false;
    },
}

export const getters = {
    isLoggedIn(state) {
        return state.loggedIn;
    },
    getUser(state) {
        return JSON.parse(state.currentUser);
    },
    getToken(state) {
        return state.userToken;
    },
    getRole(state) {
        return state.userRole;
    }
}

export const actions = {
    getAuthUser({ commit }) {
        return new Promise((resolve, reject) => {
            const unsubscribe = auth.onAuthStateChanged(async (user) => {
                if (user) {
                    commit("SET_CURRENT_USER", JSON.stringify(user));
                    commit("SET_LOGGED_IN");
                    const token = await user.getIdToken();
                    commit("SET_USER_TOKEN", token);
                    const tokenInfo = await user.getIdTokenResult();
                    commit("SET_USER_ROLE", tokenInfo.claims);

                    resolve({
                        authenticated: true,
                        data: user,
                        role: tokenInfo.claims
                    })
                } else {
                    resolve({
                        authenticated: false
                    })
                }
                unsubscribe();
            }, reject);
        })
    },

    authAction({ commit }) {
        auth.onAuthStateChanged(user => {
           if (user) {
               commit("SET_LOGGED_IN");
               const userStatusDatabaseRef = db.ref('admin-status/' + user.uid);
               db.ref('.info/connected').on('value', function(snapshot) {
                   window.console.log(".info/connected", snapshot.val());
                   if(snapshot.val() === false){
                       return;
                   }
                   userStatusDatabaseRef.onDisconnect().remove().then(() => {
                       window.console.log("onDisconnect");
                   });
               })

           } else {
               commit("SET_CURRENT_USER", null);
               commit("SET_USER_TOKEN", null);
               commit("SET_USER_ROLE", null);
               commit("SET_LOGGED_OUT");
           }
        });

        auth.onIdTokenChanged(async(user) => {
            if (user) {
                const token = await user.getIdToken();
                commit("SET_USER_TOKEN", token);
                const tokenInfo = await user.getIdTokenResult();
                commit("SET_USER_ROLE", tokenInfo.claims);
            }
        });
    },

    async logIn({commit}, payload) {
        try {
            const {user} = await auth.signInWithEmailAndPassword(payload.email, payload.passwd);
            commit("SET_LOGGED_IN");
            return {
                user: user
            }
        } catch (error) {
            window.console.error(error);
            return {
              error: error
            };
        }
    },

    // Logs out the current user.
    async logOut({ commit }) {
        await auth.signOut();
        commit("SET_CURRENT_USER", null);
        commit("SET_USER_TOKEN", null);
        commit("SET_USER_ROLE", null);
        commit("SET_LOGGED_OUT");
    },
}